var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { AccordionItem } from "../Form";
import { Attachments } from "./Attachments";
import parse from "html-react-parser";
import styled from "styled-components";
import { MESSAGE, MESSAGE_TITLE, MESSAGE_HEADER, MESSAGE_BODY } from "../../classConstants";
import get from "lodash/get";
import { getClassName } from "../../helpers";
import { usePresentationComponent } from "../../AppContext";
var MessageItem = styled(AccordionItem)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .", " {\n        padding: 1em;\n        background: var(--ws-message-header-bg);\n        color: var(--ws-message-header-text, currentColor);\n        margin-bottom: 0;\n    }\n\n    .", " {\n        padding: 1em;\n        background: var(--ws-message-body-bg);\n        color: var(--ws-message-body-text, currentColor);\n    }\n"], ["\n    .", " {\n        padding: 1em;\n        background: var(--ws-message-header-bg);\n        color: var(--ws-message-header-text, currentColor);\n        margin-bottom: 0;\n    }\n\n    .", " {\n        padding: 1em;\n        background: var(--ws-message-body-bg);\n        color: var(--ws-message-body-text, currentColor);\n    }\n"])), MESSAGE_HEADER, MESSAGE_BODY);
export var Message = function (_a) {
    var _b = _a.item, item = _b === void 0 ? {} : _b, index = _a.index, title = _a.title, props = __rest(_a, ["item", "index", "title"]);
    var MessageComponent = usePresentationComponent("message") || React.Fragment;
    var children = (React.createElement(React.Fragment, null,
        parse(get(item, "body", "")),
        React.createElement(Attachments, { item: item })));
    var itemProps = {
        children: get(props, "children", children),
        title: title,
        header_classname: MESSAGE_HEADER,
        title_classname: MESSAGE_TITLE,
        body_classname: MESSAGE_BODY,
        defaultCollapsed: props.defaultCollapsed,
    };
    return (React.createElement(MessageComponent, null,
        React.createElement(MessageItem, __assign({ className: getClassName(MESSAGE, props.className), itemIndex: index }, itemProps))));
};
var templateObject_1;
